module.exports = __webpack_public_path__ + "static/media/wonton-warrior.3219dd36.jpg";